module.exports = __webpack_public_path__ + "img/bw.21d9d9f0.svg";